import { BrandFiltersResponse } from "../../components/my-brand-screen/types";
import { SelectedFilters } from "../../components/my-campaigns-screen/types";
import { DashboardStoredFilters } from "../../services/dashboard.service";

export interface MessagingGalleryFilters {
  sortField?: string;
  isAsc?: boolean;
  themes?: string[];
}

type LocalStorage = {
  my_brand_filters: BrandFiltersResponse,
  my_competition_filters: BrandFiltersResponse,
  my_campaign_filters: SelectedFilters,
  account: string,
  dashboard_filters: DashboardStoredFilters,
  messaging_gallery_filters: MessagingGalleryFilters,
  managed_brands_signals_visibility: Record<string, boolean>
}

export enum LocalStorageKeys {
  CAMPAIGN_FILTERS = "my_campaign_filters",
  ACCOUNT = "account",
  DASHBOARD_FILTERS = "dashboard_filters",
  MESSAGING_GALLERY_FILTERS = "messaging_gallery_filters",
  MANAGED_BRANDS_SIGNALS_VISIBILITY = "managed_brands_signals_visibility"
}

export const LOCAL_STORAGE_PREFIX = "insight_hub"
export const SESSION_STORAGE_PREFIX = "insight_hub_se"

export type StorageSchemas = {
  LOCAL: LocalStorage;
  SESSION: undefined;
};

export type StorageNamespace = keyof StorageSchemas;
export type StorageKeys<N extends StorageNamespace> = keyof StorageSchemas[N];

export type StorageValue<
  N extends StorageNamespace,
  K extends StorageKeys<N>,
> = StorageSchemas[N][K];

